module.exports = __webpack_public_path__ + "img/icon-linkedin.da55500c.svg";